/**
 * @class AbstractResult
 */
class AbstractResult{
    constructor(data){
        let result = {
            feature: data.feature,
            target: data.target,
            type: "abstract"
        };
        return result;
    }
}

module.exports = AbstractResult;